import { configureStore } from '@reduxjs/toolkit';
import loaderReducer from './features/loader';
import userReducer from './features/user';
import toastReducer from './features/toast';
import registrationReducer from './features/registration';
import roleReducer from './features/roles';
import dialogReducer from './features/dialog';
import filterReducer from './features/filter';
import languageReducer from './features/language'

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    user: userReducer,
    toast: toastReducer,
    registration: registrationReducer,
    roles: roleReducer,
    dialog: dialogReducer,
    filter: filterReducer,
    language: languageReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
